export const getPlatformAdminSteps = () => [

  // ── Step 1 — Welcome ──────────────────────────────────────────────────────
  {
    target: null,
    isWelcome: true,
    title: 'Welcome to AIDAS',
    content: 'Your platform administration console — full control over partners, tenants, users, and content distribution.',
  },

  // ── Step 2 — Partners ─────────────────────────────────────────────────────
  {
    target: '#sidebar-partners',
    title: 'Partner Management',
    content: 'Create and manage partner organisations who distribute your platform to end tenants.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 3 — Tenants ──────────────────────────────────────────────────────
  {
    target: '#sidebar-tenants',
    title: 'Tenant Management',
    content: 'Onboard and monitor individual customer workspaces across the platform.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 4 — Users ────────────────────────────────────────────────────────
  {
    target: '#sidebar-users',
    title: 'User Administration',
    content: 'Manage global users, assign roles, and control access across the entire platform.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 5 — Roles & Permissions ──────────────────────────────────────────
  {
    target: '#sidebar-roles-permissions',
    title: 'Roles & Permissions',
    content: 'Configure fine-grained Role-Based Access Control and build custom roles.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 6 — Plans ────────────────────────────────────────────────────────
  {
    target: '#sidebar-plans',
    title: 'Plans & Tiers',
    content: 'Define subscription plans and toggle features available to different pricing tiers.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 7 — Credits ──────────────────────────────────────────────────────
  {
    target: '#sidebar-credits',
    title: 'Credit Management',
    content: 'Allocate usage credits and monitor consumption across partners and tenants.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 8 — Flows ────────────────────────────────────────────────────────
  {
    target: '#sidebar-flows',
    title: 'Flow Builder',
    content: 'Build, test, and publish automation workflows using the visual node editor.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 9 — Dashboards ───────────────────────────────────────────────────
  {
    target: '#sidebar-dashboards',
    title: 'Dashboard Studio',
    content: 'Create and publish interactive BI dashboards with drag-and-drop widgets.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 10 — Business Apps ───────────────────────────────────────────────
  {
    target: '#sidebar-business-apps',
    title: 'Business App Bundles',
    content: 'Package dashboards and workflows together into deployable app bundles.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 11 —  ──────────────────────────────────────────────────
  {
    target: '#sidebar-ai-insight',
    title: 'Agentic Insights',
    content: 'Configure natural language data analytics for tenants to query their data.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 12 — Data Sources ────────────────────────────────────────────────
  {
    target: '#sidebar-datasources',
    title: 'Data Sources',
    content: 'Connect databases, file stores, and APIs to power dashboards and workflows.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 13 — Data Models ─────────────────────────────────────────────────
  {
    target: '#sidebar-datamodels',
    title: 'Data Models',
    content: 'Define the semantic structure of your data for clean, consistent metrics.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 14 — Scheduler ───────────────────────────────────────────────────
  {
    target: '#sidebar-automations',
    title: 'Scheduler',
    content: 'Set up recurring schedules and event-based triggers for your automations.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 15 — Platform Settings ───────────────────────────────────────────
  {
    target: '#sidebar-platform-settings',
    title: 'Platform Settings',
    content: 'Configure integrations, relay agents, security policies, and white-label branding.',
    skipIfNotFound: true,
    scrollIntoView: true,
  },

  // ── Step 16 — Finish ──────────────────────────────────────────────────────
  {
    target: null,
    isWelcome: true,
    title: "You're all set!",
    content: "You've seen all the key areas of the platform. Restart this tour any time from your profile menu.",
  },

];
